<template>
  <section class="w-100">
    <div v-show="!resale.loading" class="login-box mx-auto">
      <div class="card">
        <div class="card-body login-card-body rounded">
          <div class="login-logo">
            <img width="100%" height="auto" :src="resale.logo">
          </div>
          <confirm-email v-show="$route.params.tokenId"></confirm-email>
          <p v-show="error === '' && success === '' " class="login-box-msg">{{ $t('message.login_message') }}</p>
          <div v-if="error !== ''" class="alert flat alert-danger alert-dismissible pl-3 pr-5">
            <button type="button" @click="resetMsg" class="close" data-dismiss="alert" aria-hidden="true">×</button>
            <p><i class="icon fa fa-exclamation-triangle"></i>{{$t('message.401_error')}}</p>
            &nbsp;{{error}}
          </div>
          <div v-if="((success !== '') && (!success.title))"
            class="alert flat bg-green disabled alert-dismissible pl-3 pr-5">
            <button type="button" @click="resetMsg" class="close" data-dismiss="alert" aria-hidden="true">×</button>
            <p>
              <i class="icon fa fa-check"></i>{{$t('message.session_close')}}</p>
            &nbsp;{{success}}
          </div>
          <div v-else-if="(success.title)" class="alert flat bg-green disabled alert-dismissible pl-3 pr-5">
            <button type="button" @click="resetMsg" class="close" data-dismiss="alert" aria-hidden="true">×</button>
            <p> <i class="icon fa fa-check"></i>{{success.title}} </p>
            &nbsp;{{success.message}}
          </div>
          <div class="form-group">
            <input type="text" name="email" :class="{ 'is-invalid': errors.has('email') }" v-model="request.email"
              class="form-control" v-bind:placeholder="$t('attributes.email')" v-validate="'required|email'"
              @keyup.enter="signIn()" @keyup="clearSignInError()">
            <span class="glyphicon glyphicon-envelope form-control-feedback"></span>
            <div class="invalid-feedback help-block error">{{errors.first('email')}}</div>
          </div>
          <div class="form-group">
            <input type="password" name="password" :class="{ 'is-invalid': errors.has('password') }"
              v-model="request.password" class="form-control" v-bind:placeholder="$t('attributes.password')"
              v-validate="'required|min:4'" @keyup.enter="signIn()" @keyup="clearSignInError()">
            <span class="glyphicon glyphicon-lock form-control-feedback"></span>
            <div class="invalid-feedback help-block error">{{errors.first('password')}}</div>
          </div>
          <div class="row mx-0 align-items-center justify-content-around">
            <div class="col-md-8 px-0">
              <p-check class="p-switch p-fill" v-model="request.remember" color="primary">{{$t('message.remember')}}
              </p-check>
            </div>
            <div class="col-md-4 px-0">
              <button type="button" @click="signIn()" :disabled="loading" class="btn btn-primary w-100">
                <span class="px-2">{{ $t('words.sign_in') }}</span> <i v-show="loading"
                  class="fa fa-circle-o-notch fa-spin"></i>
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-md-8">
              <!-- <router-link to="/password/recovery">{{ $t('words.i_forgot_my_password') }}</router-link> -->
              <a @click="status.box='recoveryPassword'" href="#">{{ $t('words.i_forgot_my_password') }}</a>
            </div>
          </div>
          <div class="row justify-content-center my-3">
            <a @click="status.box='cadastrar'" class="exp"> {{ $t('words.trial') }} </a>
          </div>
          <div class="row h-100 justify-content-center">
            <ul class="p-0 my-2">
              <a target="_blank" :href="resale.link_facebook">
                <li class="icon btn-outline-info rounded-circle mx-2">
                  <i class="fa fa-facebook"></i>
                </li>
              </a>
              <a target="_blank" :href="resale.link_instagram">
                <li class="icon btn-outline-info rounded-circle mx-2">
                  <i class="fa fa-instagram"></i>
                </li>
              </a>
              <a target="_blank" :href="resale.link_linkedin">
                <li class="icon btn-outline-info rounded-circle mx-2">
                  <i class="fa fa-linkedin"></i>
                </li>
              </a>
              <a target="_blank" :href="resale.link_youtube">
                <li class="icon btn-outline-info rounded-circle mx-2">
                  <i class="fa fa-youtube-play"></i>
                </li>
              </a>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <m-choice-company @showTwoFactoryModal="showTwoFactoryModal" ref="mChoiceCompany" :request="request">
    </m-choice-company>
    <m-two-factory-email ref="mTwoFactoryEmail" :request="request"></m-two-factory-email>
    <m-two-factory-google ref="mTwoFactoryGoogle" :request="request"></m-two-factory-google>
  </section>
</template>

<script>
  import MChoiceCompany from './components/m-choice-company.vue';
  import MTwoFactoryEmail from './components/m-two-factory-email.vue';
  import MTwoFactoryGoogle from './components/m-two-factory-google.vue';
  import confirmEmail from './ConfirmEmail.vue';
  export default {
    props: ['status', 'resale'],
    components: {
      confirmEmail,
      MChoiceCompany,
      MTwoFactoryEmail,
      MTwoFactoryGoogle
    },
    data() {
      return {
        request: {
          email: null,
          password: null,
          remember: false,
          companyId: null,
          token_otp: null
        },
        loading: false,
        error: '',
        success: '',
        loginMsg: '',
        companies: [],
        
      };
    },
    mounted() {
      this.error = this.$route.params.error ? this.$route.params.error : '';
      this.success = this.$route.params.success ? this.$route.params.success : '';
    },
    beforeMounted() {
      this.$request.check().then(response => {
        if (response) {
          this.$router.push({
            name: 'index'
          });
        } else {
          localStorage.clear();
        }
      });
      
    },
    methods: {
      resetMsg() {
        this.message = '';
        this.error = '';
      },
      signIn() {
        this.request.email = this.request.email.replace(/\s/g, '');
        this.$validator.validateAll(['email', 'password']).then(valid => {
          if (!valid) {
            return;
          }
          this.loading = true;
          this.$auth.login(this.request)
            .then(response => {
              if (response.data.access_token) {
                window.location.href="/dashboard";
              } else {
                this.$refs.mChoiceCompany.show(response);
              }
            }).catch(error => {
              if (error.data.two_factory) {
                this.showTwoFactoryModal(error);
                return;
              }
              if (typeof error.data.message != 'undefined') {
                toastr({
                  icon: error.data.status,
                  title: error.data.message
                });
              }
            }).finally(fn => {
              this.loading = false;
            })
        });
      },
      clearSignInError() {
        this.signin_error = null;
      },
      showTwoFactoryModal(error) {
        error.data.two_factory == 'E' ?
          this.$refs.mTwoFactoryEmail.show(error) : this.$refs.mTwoFactoryGoogle.show(error);
      }
    }
  };
</script>

<style scoped src="@/assets/sass/bootstrap4.css"></style>
<style scoped>
  /* body {
    background-image: url("../../assets/body.jpg");
    background-size: 100vw 100vh;
    background-attachment: fixed;
  } */
  .login-box {
    max-width: 100%;
    margin: 0;
  }

  .login-box-body {
    /* margin-top: -15%; */
    /* background-color: rgba(255, 255, 255, .15); */
    background: #ffffffdd !important;
  }

  .login-box-body .form-control {
    background-color: transparent;
    border: 0;
    border-bottom: 1px solid dimgray;
  }

  .login-box-body input.form-control::placeholder {
    color: dimgray;
  }

  .login-box-body input.form-control:focus {
    outline-width: 0;
  }

  .login-box-body .form-control-feedback {
    left: 0;
  }

  .login-box-body .has-feedback .form-control {
    padding-right: 12px;
    padding-left: 30px;
  }

  /* 
  .login-img {
    margin-top: 5%;
    width: 40vw;
    right: -20%;
    position: relative;
    overflow: hidden;
  } */

  ul .icon {
    border: 1px solid;
    display: inline-block;
    font-size: 16px;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    transition: .2s;
  }

  @keyframes pulse {
    from {
      transform: translateX(-50%) skewX(-15deg);
    }

    to {
      transform: translateX(900%) skewX(-15deg);
    }
  }

  @-webkit-keyframes pulse {
    from {
      -webkit-transform: translateX(-100%) skewX(-15deg);
    }

    to {
      -webkit-transform: translateX(400%) skewX(-15deg);
    }
  }

  @-moz-keyframes pulse {
    from {
      -moz-transform: translateX(-100%) skewX(-15deg);
    }

    to {
      -wemozbkit-transform: translateX(400%) skewX(-15deg);
    }
  }

  @-ms-keyframes pulse {
    from {
      -ms-transform: translateX(-100%) skewX(-15deg);
    }

    to {
      -ms-transform: translateX(400%) skewX(-15deg);
    }
  }

  @-o-keyframes pulse {
    from {
      -o-transform: translateX(-100%) skewX(-15deg);
    }

    to {
      -o-transform: translateX(400%) skewX(-15deg);
    }
  }

  .exp {
    /* background-color: #0db0ed; */
    color: #0db0ed;
    font-size: 18px;
    text-decoration: underline;
    font-weight: 600;
    cursor: pointer;
    animation-name: anim-exp;
    animation-duration: 3s;
    animation-iteration-count: infinite;
  }

  @keyframes anim-exp {
    0% {
      transform: scale(1);
    }

    25% {
      transform: scale(1.2);
    }

    75% {
      transform: scale(1.2);
    }

    100% {
      transform: scale(1);
    }
  }
</style>